import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import { Formik } from 'formik';
import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';
import firstWordCapitalized from 'common/util/firstWordCapitalized';

import SrFormikField from 'client/components/SrFormikField';
import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';

import postWithState from 'client/actions/postWithState';
import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';
import branch from 'client/core/branch';
import {
  SR_API_ACTION_HOUSEHOLD_UPDATE_APPLICATION,
} from 'api/actionTypes';
import getApplicationFormFields, {
  APPLICATION_FORM_TYPE_ADMIN_PREQUAL,
} from 'common/householdApplication/applicationFormFields';

@branch()
class SrAdminRenterPrequal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    reloadDataTableTour: PropTypes.func.isRequired,
    tour: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isSubmitted: false,
    };
  }

  _onSubmitPrequalForm = (values) => {
    const { dispatch, reloadDataTableTour, tour, onClose } = this.props;
    const prequalFormValues = { ...values };

    Object.keys(values).forEach((key) => {
      if (prequalFormValues[key] === '') {
        prequalFormValues[key] = null;
      }
    });

    const prequalFormPetValues = prequalFormValues.pets.slice(0, prequalFormValues.petCount);

    dispatch(postWithState, {
      action: SR_API_ACTION_HOUSEHOLD_UPDATE_APPLICATION,
      queryId: `prequal-${tour.user.id}`,
      payload: {
        userId: tour.user.id,
        updates: {
          ...prequalFormValues,
          pets: prequalFormPetValues,
        },
      },
    }).then(() => {
      this.setState({ isSubmitted: true });
      setTimeout(onClose, 1000);
    }).then(reloadDataTableTour);
  }

  _getApplicationFormFields = (values) => {
    return getApplicationFormFields({
      formValues: values,
      formType: APPLICATION_FORM_TYPE_ADMIN_PREQUAL,
    });
  }

  render() {
    const { tour } = this.props;
    const { isSubmitted } = this.state;
    const renterProfile = tour.renterProfile;

    return (
      <Portal>
        <div className='adminModal page-admin renterPrequal'>
          <div className='backdrop' onClick={this.props.onClose}>
            <div
              className='form formThemeAdmin'
              onClick={(event) => event.stopPropagation()}
            >
              <h1 className='title'>Prequalification for {firstWordCapitalized(tour.user.name)}</h1>
              <div className='subhead'>
                <span className='detail'>
                  {momentWithAustinTimezone(tour.renterMoveInDate).format('MM/DD/YYYY')} Move-in Date
                </span>
                <span className='detail additional'>
                  Phone {tour.user.phone}
                </span>
              </div>
              <div>
                <Formik
                  enableReinitialize
                  initialValues={createInitialValues({
                    formFields:this._getApplicationFormFields({
                      ...renterProfile,
                      petCount: 4,
                    }),
                    defaultValues: {
                      ...renterProfile,
                    },
                  })}
                  onSubmit={this._onSubmitPrequalForm}
                  validate={(values) => {
                    const formFields = this._getApplicationFormFields(values);
                    return createFormValidationFn(formFields);
                  }}
                  render={(formikBag) => {
                    const formFields = this._getApplicationFormFields(formikBag.values);
                    return (
                      <div>
                        {formFields.map((formField) => (
                          <SrFormikField
                            key={formField.id}
                            formField={formField}
                            formikBag={formikBag}
                          />
                        ))}

                        <ButtonDeprecated
                          className='save'
                          theme={BUTTON_THEME_BLUE}
                          onClick={formikBag.handleSubmit}
                          disabled={!formikBag.isValid || isSubmitted}
                        >
                          {isSubmitted ? 'updated!' : 'update'}
                        </ButtonDeprecated>
                      </div>
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

SrAdminRenterPrequal.displayName = 'SrAdminRenterPrequal';

export default SrAdminRenterPrequal;
